import { SET_ENV } from '../../constant';
import { envP } from '../../../utils/environments';

const initState = envP.PRD;

const envReducer = (state = initState, action) => {
  const type = action.type;
  switch (type) {
    case SET_ENV:
        return action.env;
    default:
      return state;
  }
};

export { envReducer };
